import { Component, ElementRef, HostListener, Input, OnInit, ViewChild } from '@angular/core';
import { BonusLevel } from '@model/bonus-level';
import { MobileService } from '@service/mobile.service';
import { UserService } from '@service/user/user.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'level-progress-bar',
  templateUrl: './level-progress-bar.component.html',
  styleUrls: ['./level-progress-bar.component.scss']
})
export class LevelProgressBarComponent implements OnInit {

  public environment = environment

  @Input()
  public set levels(levels: Array<BonusLevel>) {
    this._levels = levels
    this.calcProgress()
  }
  public get levels(): Array<BonusLevel> {
    return this._levels
  }
  private _levels: Array<BonusLevel> = null

  @ViewChild('graybar')
  public set graybar(e: ElementRef) {
    this._graybar = e
    this.calcProgress()
  }
  public get graybar(): ElementRef {
    return this._graybar
  }
  private _graybar: ElementRef = null

  public orange_length: string = "0px"

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.calcProgress()
  }

  public points_missing_to_next_level: number = 0

  constructor(
    public UserService: UserService,
    public MobileService: MobileService
  ) { }

  ngOnInit(): void {
    this.UserService.userObservable.subscribe(user => {
      if (user) {
        this.calcProgress()
      }
    })
  }

  private calcProgress() {

    if (!this.graybar)
      return

    if (!this.UserService.user)
      return

    if (!this.levels || !this.levels.length)
      return

    /*
      ASSUMPTIONS BECAUSE OF DESIGN
      - level 1 starts with 0 points - everyone always has it
    */

    // easier access
    let current_points = this.UserService.user.bonus_points

    // find max length in px
    let max_length_px = this.graybar.nativeElement.offsetWidth
    let length_per_level_px = max_length_px / (this.levels.length - 1) // -1 because last level has no length

    /*
      loop fusion for performance :)
      - mark completed levels
      - accumulate orange_length to current level
    */
    let levels_reached = 0
    for (let level of this.levels) {

      // reset "completed" flag from old runs
      level["completed"] = false

      // if level reached mark it
      if (current_points >= level.needed_points) {
        level["completed"] = true
        levels_reached++
      }
    }

    // if last level reached
    if (this.levels.length == levels_reached) {
      this.orange_length = ((levels_reached - 1) * length_per_level_px) + "px"
      return
    }

    // determine reached length between current and next level
    let current_level: BonusLevel = this.levels[levels_reached - 1] ? this.levels[levels_reached - 1] : this.levels[0]
    let next_level: BonusLevel = this.levels[levels_reached]
    this.points_missing_to_next_level = next_level.needed_points - current_points
    let all_points_for_next_level = next_level.needed_points - current_level.needed_points
    let points_toward_next_level = all_points_for_next_level - this.points_missing_to_next_level

    let difference_length_px = (length_per_level_px / all_points_for_next_level) * points_toward_next_level

    // console.log("all_points_for_next_level: ",all_points_for_next_level)
    // console.log("points_toward_next_level: ",points_toward_next_level)
    // console.log("difference_length_px: ",difference_length_px)

    /*
      final length is levels*length_per_level_px + current_length_px
      levels_reached-1 because level one starts without bar
    */
    this.orange_length =
      ((levels_reached - 1) * length_per_level_px) +  // length to current level
      difference_length_px +                      // length between current and next level
      "px"
  }
}